<template>
  <div class="grid grid-cols-12 justify-between pb-4">
    <TText variant="semibold" classes="mb-0 row-start-1 col-start-1 col-span-9">
      {{ name }}
    </TText>
    <TText
      size="lg"
      classes="mb-0 row-start-1 col-start-10 col-span-3 text-right"
    >
      {{ toEuro(price) }}
    </TText>
    <TText
      size="sm"
      color="text-gray-600"
      classes="mb-0 row-start-2 col-start-1 col-span-12"
    >
      {{ description }}
    </TText>
  </div>
</template>
<script lang="ts" setup>
defineProps<{
  name: string
  price: number
  description?: string
}>()
</script>
